module.exports = __webpack_public_path__ + "assets/img/btn-more-d62e4bc5.png";